 <template>
  <span class="md-title" style="text-transform: lowercase">
    {{ currentTitle }}
    <div class="md-subhead">{{ subTitle }}</div>
  </span>
</template>

<script>
import { eventBus } from "../eventbus";

export default {
  name: "UserNavTitle",
  data: function () {
    return {
      title: null,
      subTitle: null,
    };
  },
  computed: {
    currentTitle() {
      return truncate(this.title, 14);

      function truncate(source, size) {
        if (source == null) return null;
        return source.length > size ? source.slice(0, size - 1) + "…" : source;
      }
    },
  },
  created: function () {
    var self = this;

    eventBus.$on("update-dialog-title", function (title, subtitle) {
      self.title = title;
      self.subTitle = subtitle;
    });
  },
};
</script>

<style>
</style>